import type { InternalPermission } from 'src/constants/internal-access/internalPermissions'

/**
 * True when nothing is required, or when at least one required permission is held.
 * `/v1/internal/auth/me` expands `allPermissions` roles, so plain membership is correct for every
 * role. Client gating only hides what the server's `@InternalAuth` would refuse.
 */
export const hasAnyPermission = (
  permissions: string[],
  required: InternalPermission[] | undefined,
): boolean => {
  if (!required || required.length === 0) {
    return true
  }

  return required.some((permission) => {
    return permissions.includes(permission)
  })
}
